/**
 * [transformBreadcrumbs]
 *  takes in an array of breadcrumbs and transforms them into an object indexed by the parent slug
 * @param  {array} breadcrumbs  an array of breadcrumb objects
 * @return {object}        returns an object with keys of different breadcrumbs, with true value
 * ...([{slug:'navigation'}, {id:'brand'}]) -> { navigation: {slug: 'nav'}, brand: {slug: 'nav'}}
 */

export const transformBreadcrumbs = (breadcrumbs, parentSlug?: string) => {
  const result = {};

  if (Array.isArray(breadcrumbs)) {
    for (const breadcrumb of breadcrumbs) {
      const crumbIndex = parentSlug ? breadcrumb.slug.split(`${parentSlug}/`)[1] : breadcrumb.slug;

      const child = breadcrumb.children;

      result[crumbIndex] = {
        ...breadcrumb,
        ...(child && transformBreadcrumbs(child, breadcrumb.slug)),
      };

      if (child) {
        result[crumbIndex].children = child;
      }
    }
  }
  return result;
};

/**
 * [createNavigationBreadcrumbStructure]
 * takes in breadcrumbs and for navigation and
 * category breadcrumbs it removes the preceding `/navigation`
 * part of the slug
 * {slug: 'navigation/brand/acne-studios} becomes {slug: 'brand/acne-studios'}
 */

export const createNavigationBreadcrumbStructure = (breadcrumbs) => {
  if (breadcrumbs?.navigation) {
    const updatedNavBreadcrumbs = { ...breadcrumbs.navigation };
    const navChildren = breadcrumbs.navigation.children;

    for (const [i, navChild] of navChildren.entries()) {
      // eslint-disable-next-line unicorn/no-array-for-each
      navChild.children?.forEach((child, index) => {
        if (!child.slug.includes('/category')) {
          // eslint-disable-next-line prefer-destructuring
          updatedNavBreadcrumbs.children[i].children[index].slug =
            child.slug.split(`navigation/`)[1];
        } else {
          // eslint-disable-next-line prefer-destructuring
          updatedNavBreadcrumbs.children[i].children[index].slug =
            child.slug.split(`navigation/category/`)[1];
        }
      });
    }

    return updatedNavBreadcrumbs;
  }
  return breadcrumbs?.navigation;
};

/**
 * [updatedCalendarBreadcrumbs]
 * takes in breadcrumbs and for the calendar section of the nav and
 * removes the parent slug section of the child breadcrumb slug
 * {slug: 'calendar/new-releases/sneakers/a-sneakers} becomes {slug: 'sneakers/a-sneakers'}
 */

export const createCalendarBreadcrumbStructure = (breadcrumbs) => {
  if (breadcrumbs?.calendar) {
    const updatedCalendarBreadcrumbs = { ...breadcrumbs.calendar };
    const navChildren = breadcrumbs.calendar.children;

    for (const [i, navChild] of navChildren.entries()) {
      // eslint-disable-next-line unicorn/no-array-for-each
      navChild.children?.forEach((child, index) => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        if (child.slug.includes(`${navChild?.slug}/`)) {
          // eslint-disable-next-line prefer-destructuring
          updatedCalendarBreadcrumbs.children[i].children[index].slug = child.slug.split(
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${navChild?.slug}/`,
          )[1];
        }
      });
    }

    return updatedCalendarBreadcrumbs;
  }
  return breadcrumbs?.navigation;
};
